import { inlineAtomNode } from '#src/tiptap/nodes/shared.ts'

export const InsertCurrentConditionsButtonNode = inlineAtomNode(
  'insert-current-conditions-button',
  'button',
  { display: { isDisplay: true } }
)
